import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";

interface PdfModalProps {
  open: boolean;
  handleClose: () => void;
  pdfUrl: string;
}

export default function PdfModal({
  open,
  handleClose,
  pdfUrl,
}: PdfModalProps): React.JSX.Element {
  return (
    <Modal
      aria-describedby="modal-modal-description"
      aria-labelledby="modal-modal-title"
      onClose={handleClose}
      open={open}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "90%",
          height: "90%",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 3,
          overflow: "hidden",
          borderRadius: "8px",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: -5,
            top: -5,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <iframe
          height="100%"
          src={pdfUrl}
          style={{ border: "none" }}
          title="PDF"
          width="100%"
        />
      </Box>
    </Modal>
  );
}
